define(["underscore"], function(_) {

  return {
    mergeProperties: function(properties, newProperties) {
      const that = this;

      _.each(newProperties, function(newValue, name) {
        var currentValue = properties[name];
        
        if (currentValue && currentValue.format !== newValue.format) {
          newValue.format = "PROPERTY";
        }

        properties[name] = newValue;

        if (currentValue && currentValue.properties) {
          if (!newValue.properties) {
            newValue.properties = currentValue.properties;
          } else {
            // merge nested properties as well
            newValue.properties = that.mergeProperties(
              currentValue.properties,
              newValue.properties
            );
          }
        }
      });

      return properties;
    },
  };
});
